export default "__VITE_ASSET__Qic4gR$c__"